// extracted by mini-css-extract-plugin
export default {"background":"HoverCard_background__8sRS3","container":"HoverCard_container__EhC0c"};